// extracted by mini-css-extract-plugin
export default {"Link":"PullRequestLink-module__Link__LkoXIxf"};